import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/firestore";

/* export const initializeFirebase = () => {
  firebase.initializeApp({
    apiKey: "AIzaSyCP0W04R22DlvMfQJD7EFvSkX37-9Y0bYY",
    authDomain: "mindi-7930f.firebaseapp.com",
    databaseURL: "https://mindi-7930f.firebaseio.com",
    projectId: "mindi-7930f",
    storageBucket: "mindi-7930f.appspot.com",
    messagingSenderId: "741562350026",
    appId: "1:741562350026:web:00753055c501577a4ff733",
    measurementId: "G-24FF00SW66",
  });
}; */

firebase.initializeApp({
  apiKey: "AIzaSyCP0W04R22DlvMfQJD7EFvSkX37-9Y0bYY",
  authDomain: "mindi-7930f.firebaseapp.com",
  databaseURL: "https://mindi-7930f.firebaseio.com",
  projectId: "mindi-7930f",
  storageBucket: "mindi-7930f.appspot.com",
  messagingSenderId: "741562350026",
  appId: "1:741562350026:web:00753055c501577a4ff733",
  measurementId: "G-24FF00SW66",
});

export const db = firebase.firestore();

export const getMessagingToken = () => {
  return new Promise((resolve, reject) => {
    const messaging = firebase.messaging();
    messaging.deleteToken();
    messaging
      .getToken({
        vapidKey:
          "BBjhntdQfilps9R7M-x97kxFBn1Wo8580WC8Td541hU0xfY0CCGV2QA6ocPahi-LEe5yhzySfgQML5stv5nWxNw",
      })
      .then((currentToken) => {
        if (currentToken) {
          resolve(currentToken);
          // Send the token to your server and update the UI if necessary
          // ...
        } else {
          // Show permission request UI
          console.log(
            "No registration token available. Request permission to generate one."
          );
          // ...
        }
      })
      .catch((err) => {
        reject("An error occurred while retrieving token.");
        // ...
      });

    messaging.onMessage((payload) => {
      console.log("Message received. ", payload);
      // ...
    });
  });
};
